/* CO2Art 2026-09-29 — the free e-book with every CO2 system (co2art-ai marketing R-NEW184, plan docs/plans/2026-09-29-ebook-cart-gift-PLAN.md;
   Karol's form 2026-09-29: a hidden 0 product, not a discount — no active code on either store combines with a product discount).
   Loaded by snippets/ebook-gift.liquid, which also prints the handles (window.co2artEbookGift): this file carries none.

   THE RULE, read from /cart.js after every cartUpdate (the product form, the builder, the kit composer, the drawer's quantity and
   remove, the artist modal …) and once when the page has loaded with a non-empty cart:
     a system in the cart = a line whose handle is one of snippets/ebook-systems.liquid (the kit composer's regulator part counts)
       → exactly ONE gift line at quantity 1 (`_gift: ebook`). ONE paid copy is folded into the gift, which remembers it
         (`_was: <variant id>`): a copy at 0 (arm B's EBOOK- code) first, else a priced one (a blog card); a gift that already
         remembers one never takes another priced copy (a second priced copy is the buyer's own). A copy at 0 NEVER stays beside the
         gift (co2art-ai e-book pre-flight B6, 2026-10-01): the EBOOK- code combines with shipping only, so a second code typed at
         checkout would price it at the full €20 / $20 — when the system leaves, the remembered copy comes back and the code
         (still on the cart) makes it 0 again.
     no system → every gift line goes; a gift that remembers a paid copy gives exactly that one back — only when `_was` is really the
       paid book's variant (read from /products/<paid>.js), never whatever a hand-made cart put there.
   Audit 2026-09-29 (sub-agent code review): the new line is ADDED FIRST and the old lines removed after it, so a failed request never
   loses the buyer's paid copy; an existing gift with the wanted properties is corrected by its key, never re-added (a re-add would
   merge into it and the key update would then delete both).
   Nothing else in the cart is ever touched. The gift's variant id comes from /products/<gift>.js — an unpublished gift answers 404
   and nothing happens. Our own changes go out as ONE cartUpdate (source 'ebook-gift', the drawer's and the cart page's sections
   bundled), which this file ignores; the rule is idempotent and a run stops after three rounds, so it can never loop. */
(function () {
  'use strict';
  var C = window.co2artEbookGift;
  if (!C || !C.gift || !C.paid || window.co2artEbookGiftOn) return;
  window.co2artEbookGiftOn = true;
  var SRC = 'ebook-gift', ROUNDS = 3;
  var SYSTEMS = String(C.systems || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  if (!SYSTEMS.length) return;
  var giftId = null, giftGone = false, paidIds = null, running = false, again = false;

  function T() { return window.theme || {}; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  /* the theme's own routes carry the market's language prefix; '.js' asks for JSON */
  function js(key, path) { var r = T().routes || {}; return (r[key] || root() + path) + '.js'; }
  function getJSON(u) {
    return fetch(u, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function post(u, body) {
    return fetch(u, {
      method: 'POST', credentials: 'same-origin', body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || (j && j.status)) throw new Error((j && (j.description || j.message)) || 'HTTP ' + r.status); return j; });
    });
  }
  function isSystem(i) { return SYSTEMS.indexOf(i.handle) > -1; }
  function props(i) { return i.properties || {}; }

  /* the gift's variant id, once per page */
  function gift() {
    if (giftId || giftGone) return Promise.resolve(giftId);
    return getJSON(root() + 'products/' + encodeURIComponent(C.gift) + '.js').then(function (p) {
      var v = p && p.variants && p.variants[0];
      if (v && v.available !== false) giftId = v.id; else giftGone = true;
      return giftId;
    }).catch(function () { giftGone = true; return null; });
  }

  /* the paid book's variant ids, once per page, only when a gift's `_was` has to be trusted */
  function paid() {
    if (paidIds) return Promise.resolve(paidIds);
    return getJSON(root() + 'products/' + encodeURIComponent(C.paid) + '.js').then(function (p) {
      paidIds = ((p && p.variants) || []).map(function (v) { return String(v.id); });
      return paidIds;
    }).catch(function () { return []; });
  }
  function sameProps(a, b) {
    var k = function (o) { return JSON.stringify(Object.keys(o || {}).filter(function (x) { return x === '_gift' || x === '_was'; }).sort().map(function (x) { return [x, String(o[x])]; })); };
    return k(a) === k(b);
  }

  /* what the cart should lose (line key → new quantity) and gain (one line) — nothing when it already obeys the rule */
  function plan(cart, id, paidOk) {
    var items = (cart && cart.items) || [], upd = {}, add = null;
    var gifts = items.filter(function (i) { return i.handle === C.gift; });
    var paidLines = items.filter(function (i) { return i.handle === C.paid; });
    var free = paidLines.filter(function (i) { return i.final_line_price === 0; });
    var priced = paidLines.filter(function (i) { return i.final_line_price > 0; });
    var was = null;
    gifts.forEach(function (g) { if (!was && props(g)._was) was = String(props(g)._was); });
    var giveBack = function () { if (was && paidOk.indexOf(was) > -1) add = { id: parseInt(was, 10), properties: null }; };
    if (items.some(isSystem)) {
      if (id) {
        var fold = !was && (free[0] || priced[0]);
        if (fold) { upd[fold.key] = fold.quantity - 1; was = String(fold.variant_id); }
        free.forEach(function (f) { upd[f.key] = 0; });   /* B6: a copy at 0 never stays beside the gift */
        var want = was ? { _gift: 'ebook', _was: was } : { _gift: 'ebook' };
        var keep = gifts.filter(function (g) { return sameProps(props(g), want); })[0];
        gifts.forEach(function (g) { if (g !== keep) upd[g.key] = 0; });
        if (keep) { if (keep.quantity !== 1) upd[keep.key] = 1; }
        else add = { id: id, properties: want };
      }
    } else if (gifts.length) {
      gifts.forEach(function (g) { upd[g.key] = 0; });
      giveBack();
    }
    return Object.keys(upd).length || add ? { upd: upd, add: add } : null;
  }

  function sections() {
    var a = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: a } }));
    return a;
  }

  /* the one new line FIRST, then the removals (a failed request never loses a line); every POST asks for the sections, the last
     answer's are the ones shown */
  function apply(p, secs) {
    var withSections = function (b) { if (secs.length) { b.sections = secs; b.sections_url = location.pathname; } return b; };
    var chain = Promise.resolve(null);
    if (p.add) chain = chain.then(function () {
      var line = { id: p.add.id, quantity: 1 };
      if (p.add.properties) line.properties = p.add.properties;
      return post(js('cart_add_url', 'cart/add'), withSections({ items: [line] }));
    });
    if (Object.keys(p.upd).length) chain = chain.then(function () { return post(js('cart_update_url', 'cart/update'), withSections({ updates: p.upd })); });
    return chain;
  }

  function sync() {
    if (running) { again = true; return; }
    running = true; again = false;
    var secs = sections(), shown = null, changed = false;
    function round(k) {
      return getJSON(js('cart_url', 'cart')).then(function (cart) {
        if (!cart) return null;
        var items = cart.items || [];
        var need = items.some(isSystem);
        var trust = items.some(function (i) { return i.handle === C.gift && props(i)._was; });
        return Promise.all([need ? gift() : Promise.resolve(giftId), trust ? paid() : Promise.resolve([])]).then(function (r) {
          var p = plan(cart, r[0], r[1]);
          if (!p || k >= ROUNDS) return cart;
          return apply(p, secs).then(function (res) { changed = true; if (res && res.sections) shown = res.sections; return round(k + 1); });
        });
      });
    }
    round(0).then(function (cart) {
      if (!changed) { try { sessionStorage.removeItem('co2art_ebook_gift_reload'); } catch (e) { /* private mode */ } return; }
      if (!cart) return;
      var ps = T().pubsub;
      if (shown && ps && ps.publish) { cart.sections = shown; ps.publish(ps.PUB_SUB_EVENTS.cartUpdate, { source: SRC, cart: cart }); return; }
      /* no section to redraw (a page without the drawer's elements yet): the cart page reloads ONCE to show its lines — the mark is
         cleared only by a later run that finds the cart already obeying the rule */
      if (document.body && document.body.classList.contains('template-cart')) {
        try { if (sessionStorage.getItem('co2art_ebook_gift_reload') === '1') return; sessionStorage.setItem('co2art_ebook_gift_reload', '1'); } catch (e) { return; }
        location.reload();
      }
    }).catch(function (err) {
      if (window.console && console.warn) console.warn('[ebook-gift]', err && err.message);
    }).then(function () {
      running = false;
      if (again) sync();
    });
  }

  function start() {
    var ps = T().pubsub;
    if (ps && ps.subscribe) ps.subscribe(ps.PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== SRC) sync(); });
    if (C.items > 0) sync();
  }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
